import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Avatar, Image, Input} from "antd";
import {getFullAddress, renderIf, renderIfElse} from "../../../Shared";
import {ItemInformation} from 'components/common/ItemInformation'
import _ from "lodash";
import {BiSolidChurch, BiSolidMapPin} from "react-icons/bi";
import {MdChurch} from "react-icons/md";
import {FaDirections} from "react-icons/fa";
import {BsCalendar2Week, BsGlobe2, BsPhoneVibrateFill} from "react-icons/bs";
import {MassTimeFillSvg} from "../../../../components/Svgs/MassTimeIconSvg";
import EmptyHolder from "../../../../components/EmptyHolder";
import {churchTypeOptions} from "../../Church/consts/churchTypeOptions";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import {Formik, useFormikContext} from "formik";
import FormActionBar from "../../../../components/form/FormActionBar";
import {compose, mapProps, pure} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {createValue} from "../../../../components/form/utils";
import {createControlledFormField} from "../../factory/createFormField";
import TextArea from "antd/lib/input/TextArea";
import SlateEditor from "../../../SlateEditor";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import {IoBookOutline, IoDocumentTextOutline} from "react-icons/io5";
import {NullAsDefault, shallowDiff} from 'views/Shared'
import LookupField from "../../../../components/LookupField";
import {renderLocationCascade} from "../../User/functions/renderLocationCascade";
import Translate from "../../../../modules/local/Translate";
import {renderDeaneryCascade} from "../../User/functions/renderDeaneryCascade";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {Field, FormActions, Section} from "../../../../components/form/ModernForm";


const formSchema = {
    title: {
        title: 'name of parish',
        children: [
            {
                name: 'name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('enter name of parish'),
                    })),
                    pure
                )(Input),
            },
        ]
    },
    owner: {
        title: 'organization interlinkages',
        children: [
            {
                name: 'owner',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={false}
                                    defaultValue={values?.owner?.title}
                                    apiPath={`/lookup/organization/get-by-types`}
                                    name={name}
                                    placeholder={t('click to select')}
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex flex-col justify-center flex-1">
                                                <div className="font-bold text-sm text-color-000 leading-snug">
                                                    {o.label}
                                                </div>
                                                {renderIf(
                                                    o.description,
                                                    <div className="font-normal text-xs text-color-300 leading-tight">
                                                        {o.description}
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        // Lưu cả object (không chỉ e.target.value = string label) vì
                                        // defaultValue phía trên đọc values.owner?.title - trước đây
                                        // chỉ lưu string nên sau khi chọn, field hiện lại rỗng.
                                        onChange(createValue('owner', e.target))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ]
    },
    parish_parent: {
        title: 'belong to the diocese',
        children: [
            {
                name: 'parish_parent',
                component: ({form, name, value, onChange}) =>
                    renderDeaneryCascade({
                        name,
                        value,
                        onChange,
                        country_id: 237,
                    }),
            },
        ],
    },
    location: {
        title: 'Province/ward',
        children: [
            {
                name: 'location',
                component: ({form, name, value, onChange}) =>
                    renderLocationCascade({
                        name,
                        value,
                        onChange,
                        country_id: 237,
                    }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    placeholder: 'short description',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 500,
                    autoSize: {minRows: 3, maxRows: 5},
                }),
            },
        ],
    },
    about: {
        title: 'introduce',
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
}

// Tái dùng thẳng các component field đã có sẵn trong formSchema (LookupField owner, cascade
// diocese/deanery, cascade province/ward, SlateEditor...) thay vì viết lại - chỉ đổi khung ngoài
// (Section/Field) cho Create/EditParishForm, cùng pattern đã dùng ở ProfileForm.js. Xem
// docs/ui/design-principles.md "Pattern: Inline CRUD trong list".
const NameInput = formSchema.title.children[0].component
const OwnerInput = formSchema.owner.children[0].component
const ParishParentInput = formSchema.parish_parent.children[0].component
const LocationInput = formSchema.location.children[0].component
const DescriptionInput = formSchema.description.children[0].component
const AboutInput = formSchema.about.children[0].component

// Gộp các nhóm mass_times (đã group theo weekdays/title từ ChurchWithMasstimesTransformer)
// thành 2 nhóm hiển thị: Chúa Nhật / Ngày thường, dùng chung cho card preview và tab Giờ Thánh Lễ
const splitMassTimeGroups = (mass_times = []) => ({
    sunday: mass_times.filter((g) => g?.sunday_mass_flag),
    weekday: mass_times.filter((g) => !g?.sunday_mass_flag),
})

const formatMassTimesPreview = (mass_times = []) => {
    const {sunday, weekday} = splitMassTimeGroups(mass_times)
    const fmt = (groups) => _.uniq(
        groups.flatMap((g) => (g.children || []).map((c) => (c.start_time || '').slice(0, 5)))
    ).sort().join(', ')
    return {sunday: fmt(sunday), weekday: fmt(weekday)}
}

const getGoogleMapsUrl = (coordinate) => coordinate?.latitude && coordinate?.longitude
    ? `https://www.google.com/maps?q=${coordinate.latitude},${coordinate.longitude}`
    : null

const MassTimeGroupBlock = ({label, groups}) => {
    if (!groups?.length) return null
    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-1 font-semibold text-xs text-color-500 uppercase tracking-wider">
                <BsCalendar2Week size={12} className="text-primary-400"/>
                {label}
            </div>
            <div className="flex flex-wrap gap-2">
                {groups.flatMap((g) => (g.children || []).map((c, i) => (
                    <span
                        key={`${g.id}-${i}`}
                        className="px-2 py-1.5 font-mono font-bold text-sm text-primary-700 bg-primary-50 rounded-md leading-tight">
                        {(c.start_time || '').slice(0, 5)}
                        {g.title && (
                            <label className="ml-1 font-medium text-2xs text-color-400 italic tracking-wide">
                                {g.title}
                            </label>
                        )}
                    </span>
                )))}
            </div>
        </div>
    )
}

const ChurchItem = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        name,
        photo,
        contact_name,
        contact_phone,
        address,
        country,
        ward,
        district,
        province,
        church_type,
        is_cathedral,
        coordinate,
        mass_times = [],
    } = item ?? {}

    const type_church = _.find(churchTypeOptions, {value: church_type})?.label
    const massTimesPreview = formatMassTimesPreview(mass_times)
    const mapsUrl = getGoogleMapsUrl(coordinate)

    return (
        <div className="flex gap-2 md:gap-3 border border-color-50 rounded-md custom-item-render relative">
            <Avatar
                size={80}
                className="flex flex-center background-200 rounded-l-md rounded-r-0"
                icon={<BiSolidChurch size={50} style={{color: '#dddddd'}}/>}
                src={photo}
            />
            <div className="flex flex-col flex-1 gap-1 py-2 min-w-0">
                <Link
                    to={getLinkToDetail(item)}
                    className="font-bold text-sm md:text-base text-color-000 hover:text-primary no-underline truncate">
                    {name}
                </Link>
                <span
                    style={{padding: '2px 8px', top: 10, right: 10}}
                    className={`w-fit absolute font-medium text-xs italic rounded-xs ${
                        is_cathedral || church_type === 3
                            ? 'bg-primary-100 text-primary-600'
                            : 'bg-blue-100 text-blue-500'
                    }`}>
                    {t(type_church)}
                </span>
                {renderIf(
                    _.some([address, country?.location_name, ward?.location_name, province?.location_name]),
                    <div className="flex items-start md:items-center gap-1 italic text-xs">
                        {isSm ?
                            <BiSolidMapPin size={isSm ? 12 : 14} style={{marginTop: isSm && 3}}
                                           className="text-color-500"/> :
                            <span className="text-color-500">
                                            {`${t('address')} : `}
                                        </span>
                        }
                        <span
                            className="flex-1 font-medium md:font-semibold text-color-300 max-lines-1 leading-snug">
                                        {getFullAddress(item)}
                                    </span>
                    </div>
                )}
                {renderIf(
                    _.some([contact_name, contact_phone]),
                    <DoubleValueItem
                        labelFirst="contact"
                        valueFirst={contact_name}
                        labelSecond={contact_phone && ' - '}
                        valueSecond={contact_phone}
                        className="text-xs"
                    />
                )}
                {renderIf(
                    massTimesPreview.sunday || massTimesPreview.weekday,
                    <div className="flex items-center gap-1 text-xs text-color-400 truncate">
                        <MassTimeFillSvg size={12} className="text-primary-400 flex-shrink-0"/>
                        {renderIf(massTimesPreview.sunday, <span>{`${t('sunday')}: ${massTimesPreview.sunday}`}</span>)}
                        {renderIf(massTimesPreview.sunday && massTimesPreview.weekday, <span className="mx-1">|</span>)}
                        {renderIf(massTimesPreview.weekday, <span>{`${t('weekday')}: ${massTimesPreview.weekday}`}</span>)}
                    </div>
                )}
                {renderIf(
                    mapsUrl,
                    <a
                        href={mapsUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="mt-1 w-fit flex items-center gap-1 font-semibold text-xs text-green-500 italic no-underline">
                        <FaDirections size={12}/>
                        {t('directions')}
                    </a>
                )}
            </div>
        </div>
    )
}


const ActionBarItem = ({icon, title, href, to, onClick, target, divider = false}) => {
    const className = `flex flex-center w-8 h-8 background-200 hover:bg-primary-50 text-color-400 hover:text-primary rounded-full cursor-pointer no-underline flex-shrink-0 ${divider ? 'ml-1 border-l border-color-50 pl-1' : ''}`

    if (to) {
        return <Link to={to} title={title} onClick={onClick} className={className}>{icon}</Link>
    }
    return (
        <a
            href={href}
            title={title}
            target={target}
            rel={target ? 'noreferrer' : undefined}
            onClick={onClick}
            className={className}>
            {icon}
        </a>
    )
}

export const DetailViewForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('overview')
    const {
        name,
        photo,
        archdiocese,
        diocese,
        deanery,
        country,
        ward,
        district,
        province,
        churches = [],
        owner,
    } = item ?? {}

    const mainChurch = _.find(churches, {is_cathedral: 1}) ?? churches[0]
    const mapsUrl = getGoogleMapsUrl(mainChurch?.coordinate)
    const hasMassTimes = churches.some((c) => c?.mass_times?.length > 0)

    const tabs = [
        {key: 'overview', label: t('general information')},
        {key: 'churches', label: `${t('church')} (${churches.length})`},
        ...(hasMassTimes ? [{key: 'masstimes', label: t('masstimes')}] : []),
    ]

    return (
        <div className="flex flex-col gap-3">
            <div className="relative overflow-hidden -mx-4 -mt-4" style={{height: isSm ? 170 : 210}}>
                {renderIfElse(
                    photo,
                    <Image
                        src={photo}
                        className="w-full h-full object-cover"
                        wrapperStyle={{width: '100%', height: '100%'}}
                        preview={true}
                    />,
                    <div
                        className="w-full h-full flex flex-center"
                        style={{background: 'linear-gradient(135deg, var(--color-primary) 0%, #4a1010 100%)'}}>
                        <MdChurch size={64} className="text-white text-opacity-20"/>
                    </div>
                )}
                <div
                    className="absolute inset-x-0 bottom-0 pointer-events-none"
                    style={{
                        height: '75%',
                        background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 100%)',
                    }}
                />
                <div className="absolute inset-x-0 bottom-0 p-3 flex flex-col gap-1">
                    <span
                        className="w-fit px-2 py-0.5 flex items-center gap-1 bg-primary text-white font-bold text-2xs uppercase rounded-full tracking-wider">
                        <MdChurch size={12}/>
                        {t('parish')}
                    </span>
                    <span className="font-bold text-lg md:text-xl text-white uppercase tracking-wide truncate leading-tight">
                        {name}
                    </span>
                    {renderIf(
                        deanery?.fullname || archdiocese?.fullname,
                        <span className="text-xs text-white text-opacity-80 truncate">
                            {[deanery?.fullname, archdiocese?.fullname].filter(Boolean).join(' • ')}
                        </span>
                    )}
                </div>
            </div>

            <div className="flex items-center justify-end gap-2">
                {renderIf(
                    mainChurch?.contact_phone,
                    <ActionBarItem
                        icon={<BsPhoneVibrateFill size={13} className="text-blue-500"/>}
                        title={t('call')}
                        href={`tel:${mainChurch?.contact_phone}`}
                    />
                )}
                {renderIf(
                    mapsUrl,
                    <ActionBarItem
                        icon={<FaDirections size={14} className="text-green-500"/>}
                        title={t('directions')}
                        href={mapsUrl}
                        target="_blank"
                    />
                )}
                {renderIf(
                    hasMassTimes,
                    <ActionBarItem
                        icon={<MassTimeFillSvg size={14} className="text-amber-500"/>}
                        title={t('masstimes')}
                        onClick={(e) => {
                            e.preventDefault()
                            setCurrent('masstimes')
                        }}
                    />
                )}
                {renderIf(
                    owner,
                    <ActionBarItem
                        icon={<BsGlobe2 size={14} className="text-indigo-500"/>}
                        title={t('homepage')}
                        to={getLinkToDetail(owner)}
                    />
                )}
            </div>

            <div className="flex items-center gap-1 p-1 background-200 rounded-full">
                {tabs.map((tabItem) => (
                    <div
                        key={tabItem.key}
                        onClick={() => setCurrent(tabItem.key)}
                        className={`flex-1 py-1.5 text-center font-semibold text-xs md:text-sm rounded-full cursor-pointer truncate transition-colors ${
                            current === tabItem.key
                                ? 'bg-primary text-white shadow'
                                : 'text-color-400 hover:text-color-000'
                        }`}>
                        {tabItem.label}
                    </div>
                ))}
            </div>

            {current === 'overview' && (
                <div className="flex flex-col gap-3">
                    <div className="p-3 border border-color-50 rounded-xl flex flex-col gap-2">
                        <div
                            className="font-semibold text-xs text-color-500 uppercase tracking-wider">
                            {t('general information')}
                        </div>
                        <div className="flex flex-col gap-2">
                            <ItemInformation className="text-sm lg:text-xs" label="archdiocese"
                                              value={archdiocese?.fullname}/>
                            <ItemInformation className="text-sm lg:text-xs" label="diocese"
                                              value={diocese?.fullname}/>
                            <ItemInformation className="text-sm lg:text-xs" label="deanery"
                                              value={deanery?.fullname}/>
                        </div>
                    </div>
                    <div className="p-3 border border-color-50 rounded-xl flex flex-col gap-2">
                        <div
                            className="font-semibold text-xs text-color-500 uppercase tracking-wider">
                            {t('address')}
                        </div>
                        {renderIf(
                            _.some([country?.location_name, ward?.location_name, district?.location_name, province?.location_name]),
                            <div className="flex items-start gap-1 text-sm lg:text-xs">
                                <BiSolidMapPin size={14} className="text-color-500 flex-shrink-0 mt-0.5"/>
                                <span className="font-semibold text-color-100">
                                    {getFullAddress(item)}
                                </span>
                            </div>
                        )}
                        {renderIf(
                            owner,
                            <div className="flex items-baseline gap-1 text-sm lg:text-xs">
                                <span className="text-color-500 whitespace-no-wrap italic">
                                    {`${t('link to')} : `}
                                </span>
                                <Link
                                    to={getLinkToDetail(owner)}
                                    className="font-semibold text-blue-600 no-underline">
                                    {owner?.title}
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {current === 'churches' && (
                <div className="flex flex-col gap-3">
                    {renderIfElse(
                        churches.length > 0,
                        <div className="flex flex-col gap-3">
                            {churches.map((e, i) => <ChurchItem key={i} item={e}/>)}
                        </div>,
                        <EmptyHolder/>
                    )}
                </div>
            )}

            {current === 'masstimes' && (
                <div className="flex flex-col gap-5">
                    {renderIfElse(
                        hasMassTimes,
                        churches.map((church, i) => {
                            const {sunday, weekday} = splitMassTimeGroups(church?.mass_times)
                            if (!sunday.length && !weekday.length) return null
                            return (
                                <div key={i} className="flex flex-col gap-3">
                                    {renderIf(
                                        churches.length > 1,
                                        <div
                                            className="font-bold text-sm text-color-000 border-b border-color-50 pb-1">
                                            {church?.name}
                                        </div>
                                    )}
                                    <MassTimeGroupBlock label={t('sunday')} groups={sunday}/>
                                    <MassTimeGroupBlock label={t('weekday')} groups={weekday}/>
                                </div>
                            )
                        }),
                        <EmptyHolder/>
                    )}
                </div>
            )}

        </div>
    )
}


export const CreateParishForm = ({
                                     onCancel = NullAsDefault,
                                     onSubmit = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }
    const initialValues = {
        name: undefined
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={({location, parish_parent, ...values}) => {
                const [province_id = null, ward_id = null] = location || []
                const [archdiocese_id = null, diocese_id = null, deanery_id = null] = parish_parent || []

                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        ward_id,
                        province_id,
                        archdiocese_id,
                        diocese_id,
                        deanery_id
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue, handleSubmit, isSubmitting, isValid} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={BiSolidChurch} title={t('name of parish')} theme="highlight">
                            <Field label={t('name of parish')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={MdChurch} title={t('belong to the diocese')} subtitle={t('optional')}>
                            <ParishParentInput name="parish_parent" value={values.parish_parent} onChange={onChange}/>
                        </Section>

                        <Section icon={BsGlobe2} title={t('organization interlinkages')} subtitle={t('optional')}>
                            <OwnerInput name="owner" value={values.owner} form={formik} onChange={onChange}/>
                        </Section>

                        <Section icon={BiSolidMapPin} title={t('Province/ward')} subtitle={t('optional')}>
                            <LocationInput name="location" value={values.location} onChange={onChange}/>
                        </Section>

                        <Section icon={IoDocumentTextOutline} title={t('short description')} subtitle={t('optional')}>
                            <DescriptionInput name="description" value={values.description} onChange={onChange}/>
                        </Section>

                        <FormActions onCancel={onCancel} submitText="create" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}

// Component riêng ở module scope cho tab của ActionModalWrapper — bắt buộc, vì
// ActionModalWrapper dùng field.component như một React component TYPE (const Component =
// field.component; <Component/>). Định nghĩa inline ngay trong tabs=[...] bên trong render sẽ
// tạo function reference mới mỗi lần re-render (mỗi keystroke) -> React coi là component type
// khác -> unmount/remount toàn bộ cây con của tab đang active -> field Lookup bị mount lại liên
// tục -> gọi lại API lookup liên tục (xem lỗi tương tự đã fix ở YellowPageForm.js).
// ActionModalWrapper dùng field.component làm React component TYPE - định nghĩa inline trong
// render (đóng qua formik.values) sẽ tạo reference mới mỗi keystroke -> remount cả tab -> mất
// focus input, LookupField gọi lại API liên tục. Phải hoist ra module scope + tự đọc live values
// qua useFormikContext() bên trong (giống ProfileForm.js).
const ParishEditOverviewTab = ({child}) => child

const ParishEditAboutTab = () => {
    const t = useTranslate()
    const {values, setFieldValue} = useFormikContext()
    const onChange = (e) => setFieldValue(e.target.name, e.target.value)
    return (
        <Section icon={IoBookOutline} title={t('introduce')} subtitle={t('optional')}>
            <AboutInput name="about" value={values.about} onChange={onChange}/>
        </Section>
    )
}

export const EditParishForm = ({
                                   item,
                                   initialValues,
                                   onCancel = NullAsDefault,
                                   onSubmit = NullAsDefault,
                               }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    // useCallback (không hoist ra module scope được vì cần đọc initialValues/t theo item đang
    // sửa) để giữ ổn định reference qua các lần re-render do gõ phím, tránh remount ChurchItem.
    const ParishEditChurchesTab = useCallback(() => {
        const {churches = []} = initialValues ?? {}
        return (
            <div className="flex flex-col gap-3">
                <div
                    className="border-b border-color-50 font-semibold text-sm text-color-500 uppercase tracking-wider">
                    {t('list of churches')}
                </div>
                {renderIfElse(
                    churches.length > 0,
                    <div className="flex flex-col gap-3">
                        {churches.map((e, i) => <ChurchItem key={i} item={e}/>)}
                    </div>,
                    <EmptyHolder/>
                )}
            </div>
        )
    }, [initialValues, t])

    const archdiocese_id = _.get(initialValues, 'archdiocese.id')
    const diocese_id = _.get(initialValues, 'diocese.id')
    const deanery_id = _.get(initialValues, 'deanery.id')
    const _parish_parent = [archdiocese_id, diocese_id, deanery_id].filter(Boolean)

    const province_id = _.get(initialValues, 'province.id')
    const ward_id = _.get(initialValues, 'ward.id')
    const _location = [province_id, ward_id].filter(Boolean)

    const _initialValues = useMemo(
        () => ({
            name: _.get(initialValues, 'name', ''),
            location: _location,
            owner: _.get(initialValues, 'owner', ''),
            parish_parent: _parish_parent,
            description: _.get(initialValues, 'description', ''),
            about: convertFromString(_.get(initialValues, 'about')),
        }),
        [initialValues]
    )

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({parish_parent, location, about, ...values}) => {
                const [province_id = null, ward_id = null] = location || []
                const [archdiocese_id = null, diocese_id = null, deanery_id = null] = parish_parent || []

                const changes = shallowDiff(values, _initialValues)
                onSubmit(_.omitBy({
                    ...changes,
                    ward_id, province_id,
                    archdiocese_id, diocese_id, deanery_id,
                    about: about ? convertToString(about) : undefined,
                }, _.isUndefined))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                const overviewContent = (
                    <div className="flex flex-col gap-4">
                        <Section icon={BiSolidChurch} title={t('name of parish')} theme="highlight">
                            <Field label={t('name of parish')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={MdChurch} title={t('belong to the diocese')} subtitle={t('optional')}>
                            <ParishParentInput name="parish_parent" value={values.parish_parent} onChange={onChange}/>
                        </Section>

                        <Section icon={BsGlobe2} title={t('organization interlinkages')} subtitle={t('optional')}>
                            <OwnerInput name="owner" value={values.owner} form={formik} onChange={onChange}/>
                        </Section>

                        <Section icon={BiSolidMapPin} title={t('Province/ward')} subtitle={t('optional')}>
                            <LocationInput name="location" value={values.location} onChange={onChange}/>
                        </Section>

                        <Section icon={IoDocumentTextOutline} title={t('short description')} subtitle={t('optional')}>
                            <DescriptionInput name="description" value={values.description} onChange={onChange}/>
                        </Section>
                    </div>
                )

                return (
                    <ActionModalWrapper
                        tab={current}
                        tabPosition="top"
                        action={<FormActionBar submitText="save"/>}
                        onTabChange={(key) => setCurrent(key)}
                        tabs={[
                            {key: 'overview', label: 'overview', component: ParishEditOverviewTab},
                            {key: 'about', label: 'introduce', component: ParishEditAboutTab},
                            {key: 'churches', label: 'churches', component: ParishEditChurchesTab},
                        ]}>
                        {overviewContent}
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}

